module.exports = __webpack_public_path__ + "static/media/clbs_head.7c856f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clbs_head.png
// module id = 648
// module chunks = 0 1